import { ModelBase } from 'store/model-base';

export class CmsReturnOrder extends ModelBase {
    public static storeName: string = 'cmsReturnOrder';

    public header: string;
    public damageHeader: string;
    public restockHeader: string;
    public summaryIcon: CmsMediaImage;
    public creditSummary: string;
    public chargeSummary: string;
    public returnDescription: string;
    public expandIcon: CmsMediaImage;
    public infoIcon: CmsMediaImage;
    public damageFeesAlertData: AlertModalData;
    public restockingFeesAlertData: AlertModalData;
    public orderItemDevice: CmsOrderItemDevice;
    public tax: CmsTax;
    public totalChargeHeader: string;
    public totalCreditHeader: string;
    public items: string;
}
